import React from 'react';

import { useOutageData, OutageVariant } from './useOutageData';
import EmptyOutageInfo from './EmptyOutageInfo';
import NoOutage from './NoOutage';
import OutagePassed from './OutagePassed';
import OutageInFuture from './OutageInFuture';

// typograf-enable
export default function OutageInfoContent() {
  const outageData = useOutageData();

  switch (outageData.variant) {
    case OutageVariant.EmptyOutageInfo: {
      return <EmptyOutageInfo />;
    }
    case OutageVariant.NoOutage: {
      return <NoOutage />;
    }
    case OutageVariant.OutagePassed: {
      const { dateFrom, dateTo } = outageData;
      return <OutagePassed dateFrom={dateFrom} dateTo={dateTo} />;
    }
    case OutageVariant.OutageInFuture: {
      const { dateFrom, dateTo } = outageData;
      return <OutageInFuture dateFrom={dateFrom} dateTo={dateTo} />;
    }
    default:
      return <EmptyOutageInfo />;
  }
}
